import { useTranslation } from "react-i18next";
import Spinner from "components/Spinner";

export const TransparentLoading = () => {
  const { t } = useTranslation();
  return (
    <div className="z-[200] absolute bg-mofidGray-40 backdrop-blur-[2px] bg-opacity-30 top-11 left-0 bottom-0 right-0 flex justify-center items-center rounded-md">
      <Spinner className={"text-primary-70"} size={22} />
      <p className={"text-base mr-2"}>{t("gettingData")}</p>
    </div>
  );
};
